import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import s from './H1.module.scss'

function H1({ className, children, bold, muted, inline, ...props }) {
  const classes = classnames(s.h1, className, {
    [s.bold]: bold,
    [s.muted]: muted,
    [s.inline]: inline
  })

  return (
    <div className={classes} role="heading" aria-level="1" {...props}>
      {children}
    </div>
  )
}

H1.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  bold: PropTypes.bool,
  muted: PropTypes.bool,
  inline: PropTypes.bool
}

H1.defaultProps = {
  className: null,
  children: null,
  bold: false,
  muted: false,
  inline: false
}

export default H1
